/**
 * Professional theme presets for quick theme application.
 * Each preset contains all 6 theme properties that map to ThemeCorporate API fields.
 */

export const themePresets = [
    {
        id: 'classic_red',
        name: 'Classic Red',
        description: 'Default membership brand color',
        colors: {
            top_navbar: '#FC6666',
            sidebar_navbar: '#CB5B5B',
            bottom_navbar: '#663434',
            text_navbar: '#FFFFFF',
            primary_button: '#F93E3E',
            text_button: '#FFFFFF',
        },
    },
    {
        id: 'navy_professional',
        name: 'Navy Professional',
        description: 'Corporate blue for a trustworthy look',
        colors: {
            top_navbar: '#1E3A5F',
            sidebar_navbar: '#152C4A',
            bottom_navbar: '#0D1B2A',
            text_navbar: '#FFFFFF',
            primary_button: '#2563EB',
            text_button: '#FFFFFF',
        },
    },
    {
        id: 'forest_executive',
        name: 'Forest Executive',
        description: 'Elegant green for premium services',
        colors: {
            top_navbar: '#1B4332',
            sidebar_navbar: '#14352A',
            bottom_navbar: '#0B2218',
            text_navbar: '#FFFFFF',
            primary_button: '#059669',
            text_button: '#FFFFFF',
        },
    },
    {
        id: 'slate_modern',
        name: 'Slate Modern',
        description: 'Minimalist dark theme for modern brands',
        colors: {
            top_navbar: '#334155',
            sidebar_navbar: '#1E293B',
            bottom_navbar: '#0F172A',
            text_navbar: '#F1F5F9',
            primary_button: '#6366F1',
            text_button: '#FFFFFF',
        },
    },
    {
        id: 'amber_luxury',
        name: 'Amber Luxury',
        description: 'Warm gold tones for luxury branding',
        colors: {
            top_navbar: '#78350F',
            sidebar_navbar: '#5C2D0E',
            bottom_navbar: '#3B1A08',
            text_navbar: '#FFFBEB',
            primary_button: '#D97706',
            text_button: '#FFFFFF',
        },
    },
    {
        id: 'violet_creative',
        name: 'Violet Creative',
        description: 'Bold purple for creative industries',
        colors: {
            top_navbar: '#4C1D95',
            sidebar_navbar: '#3B1577',
            bottom_navbar: '#2E1065',
            text_navbar: '#FFFFFF',
            primary_button: '#7C3AED',
            text_button: '#FFFFFF',
        },
    },
];

/**
 * Get a preset by its ID
 * @param {string} presetId - The preset ID to find
 * @returns {Object|undefined} The preset object or undefined
 */
export function getPresetById(presetId) {
    return themePresets.find((p) => p.id === presetId);
}
